// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__zWcX8","content":"Footer_content__39FuY","credited":"Footer_credited__5WLkz"};